import Flex from 'quarks/Flex';

import richTextParser from 'utils/richTextParser';

import type { ContentfulComponentSingleInstance } from 'graphqlTypes';
import type { FC } from 'react';

interface BodySplitProps extends ContentfulComponentSingleInstance {
  backgroundIsDark?: boolean;
}

const BodySplit: FC<BodySplitProps> = ({ body, altBody, backgroundIsDark }) => (
  <Flex
    width="100%"
    flexDirection="column"
    justifyContent="space-between"
    gap="16px"
    md={{ flexDirection: 'row', gap: '48px' }}
    css={`
      ul,
      ol {
        text-align: left;
        width: 100%;
      }
    `}
  >
    {body && (
      <Flex
        width="100%"
        maxWidth="100%"
        flexDirection="column"
        gap="16px"
        textColor={backgroundIsDark ? 'gray-200' : 'navy-900'}
        md={{ maxWidth: 'calc(50% - 24px)' }}
      >
        {richTextParser(body)}
      </Flex>
    )}
    {altBody && (
      <Flex
        width="100%"
        maxWidth="100%"
        flexDirection="column"
        gap="16px"
        textColor={backgroundIsDark ? 'gray-200' : 'navy-900'}
        md={{ maxWidth: 'calc(50% - 24px)' }}
      >
        {richTextParser(altBody)}
      </Flex>
    )}
  </Flex>
);

export default BodySplit;
